const DEFAULT_DESKTOP_FLOWER_SCALE = 90;
const DEFAULT_DESKTOP_CONTAINER_SCALE = 180;
const DEFAULT_MOBILE_GLB_SCALE_BOOST = 0.85;
const DEFAULT_MOBILE_TARGET_HEIGHT = 100;
const DEFAULT_MOBILE_TARGET_RADIUS = 145.125;

function toPositiveNumber(value) {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : 0;
}

function resolveDesktopGlbScale(resource = {}) {
    const configuredScale = toPositiveNumber(resource.detail && resource.detail.defaultScale)
        || toPositiveNumber(resource.defaultScale);
    if (configuredScale) {
        return configuredScale;
    }
    return Number(resource.type || resource.classifyId1) === 2
        ? DEFAULT_DESKTOP_CONTAINER_SCALE
        : DEFAULT_DESKTOP_FLOWER_SCALE;
}

function resolveMobileGlbScale(modelSize = {}, options = {}) {
    const height = toPositiveNumber(modelSize.y);
    const horizontalSize = Math.max(
        toPositiveNumber(modelSize.x),
        toPositiveNumber(modelSize.z)
    );
    const targetHeight = toPositiveNumber(options.targetHeight) || DEFAULT_MOBILE_TARGET_HEIGHT;
    const targetRadius = toPositiveNumber(options.targetRadius) || DEFAULT_MOBILE_TARGET_RADIUS;
    const scaleBoost = toPositiveNumber(options.scaleBoost) || DEFAULT_MOBILE_GLB_SCALE_BOOST;
    const candidates = [];

    if (height) {
        candidates.push(targetHeight / height);
    }
    if (horizontalSize) {
        candidates.push((targetRadius * 2) / horizontalSize);
    }
    return (candidates.length ? Math.min(...candidates) : 1) * scaleBoost;
}

function resolveGlbContainerScale(resource, modelSize, scaleMode = 'mobile') {
    return scaleMode === 'desktop'
        ? resolveDesktopGlbScale(resource)
        : resolveMobileGlbScale(modelSize);
}

function shouldUseDesktopGlbScale(jsonData = {}) {
    const params = jsonData.params || {};
    return !params.editorType && !!(params.editorKind || params.studioMode);
}

module.exports = {
    resolveDesktopGlbScale,
    resolveMobileGlbScale,
    resolveGlbContainerScale,
    shouldUseDesktopGlbScale
};
